
import React, { useState, useEffect } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import type { MortgageData } from "../../CalculatorTabs";
import { formatCurrencyInput, parseCurrencyInput } from "@/utils/currencyFormatting";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface HomePriceInputProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: any;
  onHomePriceChange: (value: number) => void;
}

const HomePriceInput: React.FC<HomePriceInputProps> = ({ 
  mortgageData, 
  setMortgageData, 
  autoCalculate, 
  onHomePriceChange 
}) => {
  const [displayValue, setDisplayValue] = useState(
    formatCurrencyInput(mortgageData.homePrice.toString())
  );

  useEffect(() => {
    setDisplayValue(formatCurrencyInput(mortgageData.homePrice.toString()));
  }, [mortgageData.homePrice]);

  const handleHomePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const formatted = formatCurrencyInput(inputValue);
    setDisplayValue(formatted);
    
    const cleaned = parseCurrencyInput(inputValue);
    const numericValue = cleaned ? Number(cleaned) : 0;
    onHomePriceChange(numericValue);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="homePrice" className="text-sm font-medium">
        Home Price <MetricTooltip metric="homePriceBasic" />
      </Label>
      <Input
        id="homePrice"
        type="text"
        value={displayValue}
        onChange={handleHomePriceChange}
        placeholder="$0"
        className="w-full"
      />
    </div>
  );
};

export default HomePriceInput;
